import {
    DASHBOARD_ALARM_REMOVE,
    ALARM_DETAILS_FETCH,
    ALARM_ADS_FETCH
} from './constants';
import {
    createAlarm,
    removeAlarm,
    getAlarmDetails,
    getAlarmRelatedAds
} from '../services/alarms'

export const startCreateAlarm = (body) => {
    return (dispatch, getState) => {
        return createAlarm({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            body
        })
        .then((response) => {
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startDeleteAlarm = (id=0) => {
    return (dispatch, getState) => {
        return removeAlarm({
            header: {
                Authorization: `Token ${getState().auth.token}`
            }
        }, id)
        .then((response) => {
            dispatch(deleteAlarmAction({id}))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const deleteAlarmAction = (payload) => ({
    type: DASHBOARD_ALARM_REMOVE,
    payload
});

export const startFetchAlarmDetails = (advertiseId) => {
    return (dispatch, getState) => {
        return getAlarmDetails({
            header: {
                Authorization: `Token ${getState().auth.token}`
            }
        }, advertiseId)
        .then((response) => {
            dispatch(fetchAlarmDetails(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const fetchAlarmDetails = (payload) => ({
    type: ALARM_DETAILS_FETCH,
    payload
});

export const startFetchAlarmAds = (id) => {
    return (dispatch, getState) => {
        const itemFilters = getState().alarmDetailFilters;
        return getAlarmRelatedAds({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            parameter: Object.keys(itemFilters).filter(key => !!itemFilters[key]).reduce((acc, cur) => ({
                ...acc,
                [cur]: itemFilters[cur]
            }), {}),
            id
        })
        .then((response) => {
            dispatch(fetchAlarmAds(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const fetchAlarmAds = (payload) => ({
    type: ALARM_ADS_FETCH,
    payload
});